import dayjs from 'dayjs';

function initialState() {
  return {
    collection: [],
  };
}

export default {
  namespaced: true,

  state: initialState,

  getters: {
    //
  },

  mutations: {
    addNotification(state, notification) {
      //try not to get duplicates
      const existing = state.collection.filter(notify => notify.body === notification.body && !notify.seen)

      if (existing.length < 1) {
        state.collection.unshift(notification);
      }
    },

    updateNotification(state, notification) {
      const foundIndex = state.collection.findIndex(x => x.timestamp === notification.timestamp);

      state.collection[foundIndex] = notification;
    },
  },

  actions: {
    create({ commit }, notification) {
      const timestamp = dayjs().format('YYYYMMDDHHmmssSSS');
      const { title, body, type } = notification;

      const notificationData = {
        title,
        body,
        timestamp,
        type,
        seen: false,
      };

      commit('addNotification', notificationData);

      setTimeout(() => {
        notificationData.seen = true;
        commit('updateNotification', notificationData);
      }, notification.timeout || 6000);
    },

  },
};
